<template>
    <div class="text-center">
         <a class="send-rate-form__btn" :class="new_rate.rate && new_rate.to  ? 'active' : 'disabled'"  @click="save()">Отправить отзыв</a>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'CreateRate',
    props: ['new_rate', 'to'],
    methods: {
        ...mapActions(['create_rate']),
        save() {
            
            if(!this.new_rate.rate || !this.new_rate.to)
                return false
            
            this.$emit('before_send', false)
            return false 
            this.create_rate({ rate: this.new_rate })
                .then(() => {
                    this.dialog = false
                    this.new_dialog = false
                    this.new_rate.comment = ''
                    // this.new_rate.to = ''
                    this.new_rate.progress_line = 6
                    this.new_rate.rate = 1
                    this.$emit('close_modal', false)
                })
                .catch((err) => {
                    console.log(err.message)
                })
        },
    },
}
</script>

<style scoped>
.send-rate-form__btn {
    margin-top: 40px;
    border-radius: 62px;
    padding: 20px;
    font-size: 18px;
    line-height: 1;
    color: #f8f8f8 !important;
}

.active {
    background: #ed7428;
}

.disabled {
    background: #ddd;
    pointer-events: none;
}
</style>